const MobileProfileHistoryCard = ({ row, formatDate, fieldLabels }) => {
    const field = fieldLabels[row.field] || row.field || '—';
    const oldValue = row.oldValue || '—';
    const newValue = row.newValue || '—';

    return (
        <article className="mobile-profile-history-card">
            <div className="mobile-profile-history-card__header">
                <h4>{row.section || '—'}</h4>
                <time dateTime={row.date || undefined}>{formatDate(row.date)}</time>
            </div>
            <div className="mobile-profile-history-card__field">
                <span className="mobile-profile-history-card__label">Field</span>
                <strong>{field}</strong>
            </div>
            <div className="mobile-profile-history-card__change">
                <div>
                    <span className="mobile-profile-history-card__label">Old value</span>
                    <span className="mobile-profile-history-card__value">{oldValue}</span>
                </div>
                <div>
                    <span className="mobile-profile-history-card__label">New value</span>
                    <span className="mobile-profile-history-card__value">{newValue}</span>
                </div>
            </div>
            <div className="mobile-profile-history-card__changed-by">
                <span className="mobile-profile-history-card__label">Changed by</span>
                <span>{row.name || '—'}</span>
            </div>
        </article>
    );
};

export default MobileProfileHistoryCard;
